const PdfIcon = (props) => {
  return (
    <svg
      fill="#000000"
      height="25px"
      width="25px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 128 128"
      {...props}
    >
      <g>
        <polygon points="113,25 89,25 89,1 13,1 13,57 21,57 21,9 81,9 81,33 105,33 105,119 13,119 13,127 113,127" />
      </g>
      <g>
        <path
          d="M15.4,71.2h14.4c2.7,0,4.6,0.4,6,1.2c1.3,0.8,2.2,2,2.7,3.6c0.5,1.6,0.7,3.8,0.7,6.7c0,2.7-0.2,4.8-0.6,6.4
           c-0.4,1.6-1.3,2.8-2.7,3.7c-1.4,0.9-3.4,1.3-6.1,1.3h-4.5v10h-9.9V71.2z M26.6,86.8c0.9,0,1.5-0.1,1.8-0.2c0.3-0.1,0.6-0.5,0.7-1
           c0.1-0.5,0.2-1.5,0.2-2.9s-0.1-2.3-0.2-2.9c-0.1-0.5-0.3-0.9-0.7-1s-0.9-0.2-1.8-0.2h-1.3v8.2H26.6z"
        />
        <path
          d="M42.2,71.2h10.9c4.4,0,7.4,0.5,9.2,1.4c1.8,0.9,2.9,2.5,3.4,4.5c0.4,2.1,0.6,5.6,0.6,10.6s-0.2,8.5-0.6,10.6
           c-0.4,2.1-1.6,3.6-3.4,4.5c-1.8,0.9-4.9,1.4-9.2,1.4H42.2V71.2z M53.2,96.7c1.2,0,1.9-0.1,2.3-0.4c0.4-0.3,0.6-1,0.7-2
           s0.1-3.2,0.1-6.5c0-3.3,0-5.5-0.1-6.6s-0.3-1.8-0.7-2c-0.4-0.3-1.2-0.4-2.4-0.4h-1.2v18H53.2z"
        />
        <path d="M70.3,104.2v-33H90v7.5h-9.8V85h8.4v7.5h-8.4v11.7H70.3z" />
      </g>
    </svg>
  );
};

export default PdfIcon;
